import { render } from "./BreadcrumbLayout.vue?vue&type=template&id=23f739a4"
import script from "./BreadcrumbLayout.vue?vue&type=script&lang=js"
export * from "./BreadcrumbLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__